import { render, staticRenderFns } from "./Hospitalizations.vue?vue&type=template&id=6219b907&scoped=true&"
import script from "./Hospitalizations.vue?vue&type=script&lang=js&"
export * from "./Hospitalizations.vue?vue&type=script&lang=js&"
import style0 from "./Hospitalizations.vue?vue&type=style&index=0&id=6219b907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219b907",
  null
  
)

export default component.exports